import { LegacyTimeline } from './LegacyTimeline';

export { LegacyTimeline };
export default LegacyTimeline;
